/* eslint-disable react/no-array-index-key */

import React, { memo, useState, useEffect } from "react";
import Slider from "react-slick";
import "@qlik/qlik/src/assets/vendor/slick/slick.css";
import "@qlik/qlik/src/assets/vendor/slick/slick-theme.css";
import SliderCard from "@qlik/qlik/src/components/CardDeckContainer/Home_Slider/SliderCard";
import SliderCardPopup from "@qlik/qlik/src/components/CardDeckContainer/Home_Slider/SliderCardPopup";
import SliderProgressBar from "@qlik/qlik/src/components/ContentSlider/SliderProgressBar";
import { useAppContext } from "@qlik/qlik/src/context/AppContext";

/**
 * DeckSliderCardsMobile component
 * @param {Object} props - Component props
 * @param {Array} props.cards - Array of card data
 */

const DeckSliderCardsMobile = memo(({ cards = [] }) => {
    // State variables for active index, popup index and mounted status
    const [activeIndex, setActiveIndex] = useState(0);
    const [popUpIndex, setPopupIndex] = useState(null);
    const [mounted, setMounted] = useState(false);
    const [isSliding, setIsSliding] = useState(false);

    const { setBodyClassName } = useAppContext();

    /**
     * Handler for click events
     * @param {number} index - Index of the clicked card
     */
    const onClickHandler = (index) => {
        if (!isSliding) {
            setPopupIndex(index);
            setIsSliding(false);
        }
    };
    const beforeSlideHandler = (current, next) => {
        if (current !== next) {
            setActiveIndex(next);
            setIsSliding(true);
        }
    };

    const afterSlideHandler = () => {
        setIsSliding(false);
    };

    // Effect to handle sliding status
    useEffect(() => {
        if (mounted) setIsSliding(true);
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [activeIndex]);

    // Effect to handle mounted status
    useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);
    return (
        <div className="container">
            <Slider
                className="w-full slider-cards"
                infinite={false}
                arrows={false}
                beforeChange={beforeSlideHandler}
                afterChange={afterSlideHandler}
            >
                {cards.map((card, index) => (
                    <SliderCard
                        key={`card-${card.id}-${index}`}
                        card={card}
                        className="mx-2.5"
                        onClick={() => onClickHandler(index)}
                    />
                ))}
            </Slider>
            {cards.map((card, index) => (
                <SliderCardPopup
                    key={`pop-up-${card.id}-${index}`}
                    onClose={() => {
                        setPopupIndex(null);
                        setBodyClassName("");
                    }}
                    card={card}
                    active={index === popUpIndex}
                    index={index}
                />
            ))}
            <SliderProgressBar total={cards.length} current={activeIndex + 1} className="mt-6.5" />
        </div>
    );
});

export default DeckSliderCardsMobile;
